import { i as p } from "./divider.css-Dazo8xmY.js";
import { S as d } from "./sizedMixin-B6C_XO64.js";
import { x as m } from "./lit-element-6iugfgmM.js";
import { n as l } from "./property-BWlAHqg_.js";
import { S as n } from "./Base-pdJ5fkYW.js";
import { d as f } from "./define-element-Dl91r6Vu.js";
var u = Object.defineProperty;
class a extends d(n, { validSizes: ["s", "m", "l"], noDefaultSize: !0 }) {
  constructor() {
    super(...arguments), this.vertical = !1;
  }
  render() {
    return m``;
  }
  firstUpdated(t) {
    super.firstUpdated(t), this.setAttribute("role", "separator");
  }
  updated(t) {
    super.updated(t), t.has("vertical") && (this.vertical ? this.setAttribute("aria-orientation", "vertical") : this.removeAttribute("aria-orientation"));
  }
}
a.styles = [p], ((e, t, o) => {
  for (var s, r = void 0, i = e.length - 1; i >= 0; i--) (s = e[i]) && (r = s(t, o, r) || r);
  r && u(t, o, r);
})([l({ type: Boolean, reflect: !0 })], a.prototype, "vertical"), f("sp-divider", a);
//# sourceMappingURL=sp-divider-D9CsUZj7.js.map
